var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('shop-menu-item-service-base',{attrs:{"name-text":_vm.service.name,"duration-text":_vm.durationText,"price-text":_vm.priceText,"selected":_vm.selected}})}
var staticRenderFns = []

export { render, staticRenderFns }